@import "../../variables.scss";

.workHistory {
  &__buttonContainer {
    display: flex;
    justify-content: flex-end;
    width: 100%;

    a:hover {
      text-decoration: none;
    }

    button {
      width: 140px;
      &:hover {
        text-decoration: none;
      }
    }
  }
  &__form {
    width: 364px;
    margin-left: 80px;
    margin-right: -5px;

    @media (min-width: 992px) {
      margin-right: 22px;
    }

    @media (max-width: 991px) {
      margin-top: 40px;
      margin-left: 0px;
    }

    @media (max-width: 576px) {
      width: 288px !important;
    }

    &_wrapper {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      width: 440px;

      @media (max-width: 991px) {
        justify-content: center;
      }

      @media (min-width: 1201px) {
        margin-left: 35px;
      }

      @media (min-width: 992px) {
        height: 575px;
        overflow-y: auto;
        overflow-x: hidden;
        padding-right: 13px;
        &::-webkit-scrollbar {
          width: 5px;
        }

        /* Track */
        &::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
        }

        /* Handle */
        &::-webkit-scrollbar-thumb {
          background: #888;
          border-radius: 10px;
        }

        /* Handle on hover */
        &::-webkit-scrollbar-thumb:hover {
          background: #555;
          border-radius: 10px;
        }
      }
    }
  }

  &__addAnother {
    color: $color-grey;
    background-color: white;
    text-decoration: none;
    &:hover {
      color: $color-grey;
      background-color: white;
      text-decoration: none;
    }
  }
  &__image {
    position: absolute;
    z-index: 5;
    left: 180px;
    bottom: -371px;
  }

  &__anotherJobRole {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding-left: 80px;
    @media (max-width: 991px) {
      padding: 0;
    }

  }

  &__imageBackground {
    position: relative;
    @media (max-width: 991px) {
      margin-bottom: 30px;
      padding: 0;
    }
  }

  &__imageBackground:after {
    content: "";
    width: 2032px;
    height: 1210px;
    background-color: $color-background-blue;
    position: absolute;
    left: -270%;
    top: -541px;
    border-radius: 50%;

    @media (max-width: 1200px) {
      left: -347%;
    }
    @media (max-width: 991px) {
      left: -44%;
      top: -75%;
      width: 200%;
      height: 193%;
    }
  }

  &__jobRole_container {
    @media (max-width: 991px) {
      max-height: 504px;
      overflow: auto;
    }
  }
}
